import { Router } from "@angular/router";
import { PrivacyModel } from "common/models/page-models/privacy/privacy-data-model";
import { PrivacyMetaModel } from "common/models/page-models/privacy/privacy-form-meta.model";
import { MetaModel } from "common/models/utility-models/base-model";
import { SystemService } from "common/services/core-services/system.service";
import { FormWidgetService } from "../form-widget.service";
import { PrivacyDataService } from "common/services/data-services/admin/privacy/privacy-data.service";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class PrivacyWidgetService extends FormWidgetService<PrivacyModel> {
    constructor(
        protected ds: PrivacyDataService,
        protected ss: SystemService,
        protected router: Router,
    ) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new PrivacyMetaModel();
        return meta.getMetaModel();
    }

}